import { render, staticRenderFns } from "./FiscaisView.vue?vue&type=template&id=115f5347"
import script from "./FiscaisView.vue?vue&type=script&lang=js"
export * from "./FiscaisView.vue?vue&type=script&lang=js"
import style0 from "./FiscaisView.vue?vue&type=style&index=0&id=115f5347&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports